import { Theme } from "@mui/material";
import Scrollbar from "./Scrollbar";

const ComponentsOverrides = (theme: Theme) => {
  return Object.assign(Scrollbar(theme));
};

export default ComponentsOverrides;
